'use client';

import { createContext, useContext, useRef } from 'react';
import { useStore } from 'zustand';
import { createPlaygroundStore, type PlaygroundStore } from '../_stores/playground';
type PlaygroundStoreApi = ReturnType<typeof createPlaygroundStore>;
const PlaygroundStoreContext = createContext<PlaygroundStoreApi | undefined>(undefined);
export function PlaygroundStoreProvider({
  children
}: React.PropsWithChildren) {
  const storeRef = useRef<PlaygroundStoreApi>(undefined);
  storeRef.current ??= createPlaygroundStore();
  const store = storeRef.current;
  return <PlaygroundStoreContext.Provider value={store}>
      {children}
    </PlaygroundStoreContext.Provider>;
}
export function usePlaygroundStore(selector) {
  const playgroundStoreContext = useContext(PlaygroundStoreContext);
  if (!playgroundStoreContext) {
    throw new Error("usePlaygroundStore must be used within PlaygroundStoreProvider");
  }
  return useStore(playgroundStoreContext, selector);
}